(function () {
  var TRIGGER = 'Submitted Success';
  var BOOK_CONFIRMATION_PATH = '/pages/consultation-booking-confirmation';

  function resolveTypeFromPath(pathname) {
    var path = (pathname || '').toLowerCase();
    if (path.indexOf(BOOK_CONFIRMATION_PATH) !== -1) return 'Book Consultation';
    if (path.indexOf('/virtual-consultation') !== -1) return 'Virtual';
    if (path.indexOf('/book-your-in-person-consultation') !== -1) return 'In-person';
    if (path.indexOf('/book-a-consultation') !== -1 || path.indexOf('/consultation') !== -1) return 'Book Consultation';
    if (path.indexOf('/contact') !== -1) return 'Contact Us';
    return 'Other';
  }

  function emitContactTracking(type) {
    var payload = {
      event: 'contact_us_submitted_success',
      type: type || 'Other',
      trigger: TRIGGER
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  }

  document.addEventListener('DOMContentLoaded', function () {
    var currentPath = (window.location.pathname || '').toLowerCase();
    var successMarker = document.querySelector('[data-contact-tracking-success="true"]');
    if (successMarker) {
      emitContactTracking(successMarker.getAttribute('data-contact-tracking-type') || 'Other');
      return;
    }

    var params = new URLSearchParams(window.location.search || '');
    if (params.has('contact_posted')) {
      emitContactTracking(resolveTypeFromPath(currentPath));
      return;
    }

    if (currentPath.indexOf(BOOK_CONFIRMATION_PATH) !== -1) {
      emitContactTracking('Book Consultation');
    }
  });
})();
